import Vue from 'vue'
import vuex from 'vuex'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../assets/js/public.js'
Vue.use(vuex);
var arr = []
export default new vuex.Store({
    state:{
        cartNum:0,
        routerData:[],
        pagesizeNum:0,
        categoryList:[],
        bId:'',
        aId:'',
        iscategoryList:false,
        minP:'',
        maxP:'',
        useBalance:'2',
        timer:1,
        method:-1,
        TK:'',
        freight:0,
        addressId:'',
        address:'',
        consignee:'',
        phoneNumber:'',
        allM:'',
        allN:'',
        memberMoney:'',
        coupon:'',
        gift:'',
        totalScore:'',
        pmnAddPricePrivilege:'',
        pmnGoodsPrivilege:'',
        pmnOrderPrivilege:'',
        pmnCouponPrivilege:'',
        totalAmount:'',
        difference:'',
        saleScale:0,
        cardMoney:'',
        addPriceDataList:[],
        couponData:[],
        addressLength:'',
        payPassword:null,
        cardRuleMoney:'',
        saleScale:'',
        showSaleScale:'',
        goodsAmount:'',
        contact1:'',
        contact2:'',
        teamBalanceId:'',
        promotionDataForDetailList:[],
        mallCategoryData:[],
        selfRaisingChecked:0,
        allData:[],
        indexBottomData:{}
    },
    mutations:{
        getIndexBottomHtml(state,data){
          state.indexBottomData=data
        },
        indexAllData(state,data){
          state.allData=data
        },
        setSelfRaisingChecked(state,data){
          state.selfRaisingChecked=data
        },
        getPromotionDataForDetailList_(state,data){
          state.promotionDataForDetailList=data
        },
        getTeamBalanceId(state,data){
          state.teamBalanceId=data
        },
        getContact1(state,data){
          state.contact1=data
        },
        getContact2(state,data){
          state.contact2=data
        },
        getGoodsAmount(state,data){
          state.goodsAmount=data
        },
        getShowSaleScale(state,data){
          state.showSaleScale=data
        },
        getSaleScale(state,data){
          state.saleScale=data
        },
        getCardRuleMoney(state,data){
          state.cardRuleMoney=data
        },
        payPassword(state,data){
          state.payPassword=data
        },
        getAddressLength(state,data){
          state.addressLength=data
        },
        couponData(state,data){
          state.couponData=data
        },
        addPriceDataList(state,data){
          state.addPriceDataList=data
        },
        gg(state,data){
          state.cardMoney=data
        },
        ff(state,data){
          state.saleScale=data
        },
        ee(state,data){
          state.difference=data
        },
        dd(state,data){
          state.totalAmount=data
        },
        cc(state,data){
          state.pmnCouponPrivilege=data
        },
        bb(state,data){
          state.pmnOrderPrivilege=data
        },
        aa(state,data){
          state.pmnGoodsPrivilege=data
        },
        zzz(state,data){
          state.pmnAddPricePrivilege=data
        },
        yyy(state,data){
          state.totalScore=data
        },
        xxx(state,data){
          state.gift=data
        },
        www(state,data){
          state.coupon=data
        },
        vvv(state,data){
          state.memberMoney=data
        },
        rrr(state,data){
            state.allN=data
        },
        qqq(state,data){
            state.allM=data
        },
        ppp(state,data){
            state.phoneNumber=data
        },
        ooo(state,data){
            state.consignee=data
        },
        nnn(state,data){
            state.address=data
        },
        mmm(state,data){
            state.addressId=data
        },
        lll(state,data){
            state.freight=data
        },
        kkk(state,data){
            state.TK=data
        },
        jjj(state,data){
            state.timer=data
        },
        iii(state,data){
            state.method=data
        },
        hhh(state,data){
            state.useBalance=data
        },
        ggg(state,data){
            state.minP=data.pricesmall
            state.maxP=data.pricebig
        },
        fff(state,data){
            state.aId=data
        },
        eee(state,data){
            state.bId=data
        },
        aaa(state,data){
            state.pagesizeNum=data
        },
        ccc(state){
            const url = `${ip}formWorkInterface/getCartShoppingNum`;
            let data = Qs.stringify({
                tamp:localStorage.tamp?localStorage.tamp:'',
                channel:2
            });
            axios.post(url,data)
              .then(res => {
                if(overtime(res.data.code)){
                    localStorage.removeItem('tamp')
                    localStorage.removeItem('name')
                    return this.$router.push({
                    path: '/LoginHome?state=1',
                    query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
                    });
                    this.$router.go(0);
                }
                if(res.data.code==300){
                    var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
                    return window.open(href.href,'_blank')
                }
                state.cartNum = res.data.num
              }).catch(err => {
            })
        },
        bbb(state,data){
            state.routerData = data.data
        },
        ddd(state,data){
            const url = `${ip}formWorkInterface/getGoodsByCategoryId`;
            axios.post(url,data)
              .then(res => {
                if(overtime(res.data.code)){
                  localStorage.removeItem('tamp')
                  localStorage.removeItem('name')
                  return this.$router.push({
                    path: '/LoginHome?state=1',
                    query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
                  });
                  this.$router.go(0);
                }
                if(res.data.code==300){
                    var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
                    return window.open(href.href,'_blank')
                }
                if(res.data.results.rows.length==0){
                    state.iscategoryList=true
                }else{
                    state.iscategoryList=false
                }
                state.categoryList=res.data.results
                state.routerData = res.data.results.categoryData
                state.mallCategoryData=res.data.results.mallCategoryData
              }).catch(err => {
            })
        }
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js